define('components/stratemanager/views/StrateNavView', [
    'components/stratemanager/templates/navitem'
], function( navItemTpl ) {

    var StrateNavView = Mazarine.View.extend({

        events: {
            "click .js-maz-strate-nav-item": "onClickNav"
        },

        template: navItemTpl,

        el: ".maz-strate-nav-inner",

        callbacks: {},

        addNavItem: function(strate) {
            if (strate.callback) {
                this.callbacks[strate.viewId] = strate.callback;
            }

            this.$el.append(this.template(strate));
        },

        removeNavItem: function(strateId) {
            this.$('.js-maz-strate-nav-item[data-anchor="' + strateId + '"]').remove();
        },

        selectNavItem: function(strateId) {
            this.$('.js-maz-strate-nav-item').removeClass("active");
            this.$('.js-maz-strate-nav-item[data-anchor="' + strateId + '"]').addClass("active");
        },

        onClickNav: function(e) {
            if (e) {
                e.preventDefault();
            }

            var viewId = $(e.currentTarget).data('anchor');

            if (this.callbacks[viewId]) {
                this.callbacks[viewId]();
            }
        }
    });

    return StrateNavView;
});
